import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import AnalyzeView from 'home/Activity/components/AnalyzeView';
import Loading from 'common/components/atoms/Loading';
import lazyRetry from 'common/helpers/componentLoader';
import { history } from 'common/helpers/history';
import { trackAppReturnPath } from 'common/helpers/appReturnPath';
import ChatbotWidget from 'home/Chatbot/ChatbotWidget';
import { HomePage } from '../../home';
import I18nLanguageSync from '../../i18n/I18nLanguageSync';
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';

const ReleaseNotesRoutes = lazy(() => lazyRetry(() => import('home/ReleaseNotes/ReleaseNotesRoutes')));

const renderAnalyzeView = props => (
  <ErrorBoundary name="route-analyze-view" variant="page" resetKeys={[props.location.pathname]}>
    <AnalyzeView {...props} />
  </ErrorBoundary>
);

const renderReleaseNotes = props => (
  <ErrorBoundary name="route-release-notes" variant="page" resetKeys={[props.location.pathname]}>
    <Suspense fallback={<Loading center />}>
      <ReleaseNotesRoutes />
    </Suspense>
  </ErrorBoundary>
);

const renderHomePage = props => (
  <ErrorBoundary name="route-home-page" variant="page" resetKeys={[props.location.pathname]}>
    <HomePage {...props} />
  </ErrorBoundary>
);

class ProtectedLayout extends React.Component {
  componentDidMount() {
    // Standalone pages' "Back to app" steps back to where the visit started.
    this.stopTrackingReturnPath = trackAppReturnPath(history);
  }

  componentWillUnmount() {
    this.stopTrackingReturnPath();
  }

  render() {
    return (
      <>

        <I18nLanguageSync />

        <Switch>
          <Route path="/machines/:machine_id/events-analysis" render={renderAnalyzeView} />
          {/* Release notes are standalone pages outside the app shell, so this route is a
              sibling of HomePage: opening one unmounts HomePage, and Back to app mounts
              it again (its hierarchy is fetched again and in-memory UI state, such as an
              open Admin Dashboard, starts fresh). Keeping HomePage mounted underneath
              would avoid that and is a possible follow-up. */}
          <Route path="/release-notes" render={renderReleaseNotes} />
          <Route path="/" render={renderHomePage} />
        </Switch>
        <ChatbotWidget />
      </>
    );
  }
}

export default ProtectedLayout;
